/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tangy_White_Crossbill_EmpowerInputs */

const fr_tangy_white_crossbill_empower = /** @type {(inputs: Tangy_White_Crossbill_EmpowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouve tous les utilisateurs de ton application. Tu peux les modifier et voir l'utilisation de l'application`)
};

/**

* @param {Tangy_White_Crossbill_EmpowerInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tangy_white_crossbill_empower = /** @type {((inputs?: Tangy_White_Crossbill_EmpowerInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tangy_White_Crossbill_EmpowerInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tangy_white_crossbill_empower(inputs)
});